//import React, {ChangeEvent, useState, useEffect} from "react";
import React from "react";
import "../Common/common.scss";
import './message.scss';
interface Props {
    
}

const MicrosoftLicRequirement: React.FC<Props> = (props) => {
   
    
    return (
        <div className="mesagecontainer">
            <p>You are now on a new iGlobe CRM version that includes MIPA.</p>
            <div className='ms-Grid-col ms-sm12 ms-md12 ms-lg12' style={{ paddingTop: 20 }}>
                Please contact your iGlobe administrator and request to get the tenant global administrator to give new admin consent.  
            </div>
            {/* <div style={{"color": "#ff9900"}}>IMPORTANT REQUIREMENT FOR USING MIPA!</div> 
            <ul>
                <li>The organizational Office 365 Global administrator must have secure MIPA by giving Admin consent.</li>
                <li>You must have an Office 365 subscription.</li>
                <li>You must be signed into your Office 365 account to use MIPA.</li>
                <li>Using Microsoft Planner with MIPA requires the user to be a member of the Plan and have at least one Task assigned.</li>
                <li>Using iGlobe CRM Office 365 with MIPA requires you to have a valid iGlobe CRM Office 365 application running and you must have a valid license assigned to you. Purchase iGlobe CRM at Microsoft Commercial Marketplace</li>
                <li>MIPA can only be used by a Microsoft 365 user with an active Microsoft mail account</li>
                <li>MIPA requires the user to have a Business OneDrive</li>
            </ul>

            <p>If you are not a Global Administrator. Please ask an admin to grant permission to this app before you can use it.</p>
            <div className='ms-Grid-col ms-sm12 ms-md12 ms-lg12' style={{ paddingTop: 20 }}>
                            <a className='ms-Button ms-Button--default viewswitchbtn adminconsent' href='https://login.microsoftonline.com/common/oauth2/authorize?IsDlg=1&client_id=e854ea05-68ab-4204-babe-db4a784fb4d8&scope=Web.Read%20List.Manage&response_type=code&redirect_uri=https%3A%2F%2Fmipa.iglobe.dk%2FAuth&state=onlyconsent&prompt=admin_consent'
                                target="_blank"  >Admin Consent</a>
            </div>
            <p>Should you have any questions please feel free to <a href="mailto:sales@iglobe.dk" target="_blank" rel="noopener">contact us</a>. We can also offer you a demo or assist you in the implementation. As it is a simple product, we believe it will not take more than just 30 min. <a href="https://outlook.office365.com/owa/calendar/iGlobeOffice365@iglobe.dk/bookings/" target="_blank" rel="noopener">Book us now</a></p> */}
        </div>
    )
};

export default MicrosoftLicRequirement;